<template>
  <div class="app-shell bg-white text-ink">
    <Navbar />
    <Sidenav />
    <main class="app-main">
      <router-view />
    </main>
    <Footer />
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import Navbar from '@/components/common/Navbar.vue'
import Footer from '@/components/common/Footer.vue'
import Sidenav from '@/components/common/Sidenav.vue'
import api from '@/services/api'
import { getAuthUserId, isAuthenticated, setAuthSession, setAuthUser } from '@/services/auth'

const loadProfile = async () => {
  if (!isAuthenticated()) return
  const vendorId = getAuthUserId()
  if (!vendorId) return
  const payload = new FormData()
  payload.append('vendor_id', vendorId)
  try {
    const { data } = await api.getProfileVendor(payload)
    const user = data?.user || data?.data?.user || data?.data || data?.profile || null
    if (user) {
      setAuthUser({
        ...user,
        s_id:
          user?.s_id ||
          user?.id ||
          user?.user_id ||
          user?.vendor_id ||
          user?.vendorId ||
          vendorId
      })
      setAuthSession({
        loggedIn: true,
        s_id:
          user?.s_id ||
          user?.id ||
          user?.user_id ||
          user?.vendor_id ||
          user?.vendorId ||
          vendorId
      })
    }
  } catch {
    // ignore profile load failures
  }
}

onMounted(() => {
  loadProfile()
})
</script>

<style>
:global(html, body, #app) {
  height: 100%;
} 
 

a:hover {
  text-decoration: none!important;
}
</style>
